var map = {
	"./affaere1/puzzle-green-icon.svg": 2531,
	"./affaerentreff/puzzle-green-icon.svg": 37157,
	"./casualxdates/puzzle-green-icon.svg": 26246,
	"./ficktreffpunkt24/puzzle-green-icon.svg": 82132,
	"./fremdgehboerse/puzzle-green-icon.svg": 66908,
	"./illicitoasis/puzzle-green-icon.svg": 71523,
	"./puzzle-green-icon.svg": 8905,
	"./seitensprungtreff69/puzzle-green-icon.svg": 49467
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86475;